import { render, staticRenderFns } from "./StaffHolidayWorkRequestButton.vue?vue&type=template&id=b0002f8c"
import script from "./StaffHolidayWorkRequestButton.vue?vue&type=script&lang=js"
export * from "./StaffHolidayWorkRequestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports